import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { axiosInstance } from '../../../helpers/api_helper';

export const updateSumSubVerification = createAsyncThunk(
  'licenses/updateSumSubVerification',
  async (
    { id, remark }: { id: number; remark?: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosInstance.put(`/user/mlm/kyc/sumsub-status`, {
        userId: id,
        remark: remark || undefined
      });
      toast.success(response.data.message);
    } catch (error: any) {
      toast.error(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);
